import { createFileRoute } from '@tanstack/react-router';

import { Login, loginSearchSchema } from 'features/auth/Login';

export const Route = createFileRoute('/auth/_auth/login/')({
  validateSearch: loginSearchSchema,
  component: LoginRoute
});

function LoginRoute() {
  const { redirect: redirectTo, emailVerified } = Route.useSearch();

  return <Login isEmailVerified={emailVerified} redirectTo={redirectTo} />;
}
